import { render, staticRenderFns } from "./IntegrationStep3.vue?vue&type=template&id=38c2f704&"
import script from "./IntegrationStep3.vue?vue&type=script&lang=js&"
export * from "./IntegrationStep3.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationStep3.vue?vue&type=style&index=0&id=38c2f704&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports